const base = {
  primary: {
    default: '#4ACEC6',
    transparent: '#51E0C026',
    200: '#D1F9F4',
    500: '#4ACEC6',
    700: '#2C9EA6',
    900: '#216473',
    1000: '#16384B',
  },
  secondary: {
    default: '#22938D',
    transparent: '#51E0C026',
    500: '#22938D',
    700: '#296F62',
    900: '#10493E',
    1000: '#073D32',
  },
  white: { default: '#FFFFFF' },
  black: { default: '#000000' },
  gray: {
    default: '#6F7B8B',
    50: '#F0F4FC',
    100: '#E9EDF5',
    150: '#E4E9F2',
    200: '#DAE0EB',
    300: '#C8D1DE',
    400: '#AFBAC9',
    500: '#6F7B8B',
    600: '#586473',
    700: '#3F4853',
    800: '#2E353E',
    900: '#21252A',
    1000: '#000000',
    transparent: '#6F7B8B26',
  },
  offwhite: {
    200: '#F3EFE8',
    300: '#E8E3DB',
  },
  blue: {
    default: '#414AA1',
    100: '#4972DB',
  },
  red: {
    500: '#F62A98',
  },
  system: {
    ongoing: {
      transparent: '#246DFB26',
      default: '#246DFB',
    },
    disabled: {
      default: '#afadb3',
      transparent: '#afadb326',
    },
    placeholder: {
      default: '#ADB5BD',
      transparent: '#ADB5BD26',
    },
    warn: {
      default: '#ECB935',
      transparent: '#ECB93526',
    },
    success: {
      default: '#A8E14A',
      transparent: '#A8E14A26',
    },
    error: {
      default: '#F62A98',
      transparent: '#F62A9826',
    },
  },
};

export default {
  ...base,
  gradient: {
    primary: `linear-gradient(134.08deg, ${base.primary[900]} -16.47%, ${base.primary.default} 134.79%);`,
  },
};
